import Button from "@mui/material/Button";

import Translations from "@/components/Core/Translations";
import { colors } from "@/theme";

interface NotificationMenuFooterProps {
  onSeeAll: () => void;
}

export const NotificationMenuFooter = ({ onSeeAll }: NotificationMenuFooterProps) => (
  <Button
    variant="text"
    color="primary"
    onClick={onSeeAll}
    sx={{
      width: "100%",
      py: 1.5,
      borderTop: `1px solid ${colors.grey[200]}`,
      fontWeight: 500,
    }}
  >
    <Translations text="notification.see-all" />
  </Button>
);
